/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reopen_IneligibleInputs */

const en_task_reopen_ineligible = /** @type {(inputs: Task_Reopen_IneligibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity cannot be reopened in its current context.`)
};

const pt_br2_task_reopen_ineligible = /** @type {(inputs: Task_Reopen_IneligibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade não pode ser reaberta no contexto atual.`)
};

/**
* | output |
* | --- |
* | "This activity cannot be reopened in its current context." |
*
* @param {Task_Reopen_IneligibleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reopen_ineligible = /** @type {((inputs?: Task_Reopen_IneligibleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reopen_IneligibleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reopen_ineligible(inputs)
	return pt_br2_task_reopen_ineligible(inputs)
});